<ion-item lines="full">
    <canvas #canvas (touchend)="drawComplete()" height="200"></canvas>
</ion-item>
<ion-item (click)="clearPad()" button lines="full" detail="true" detailIcon="close">
    <ion-label>
        {{ "CREATE_PROJECT.CLEAR" | translate }}
    </ion-label>
</ion-item>
